import sgccApi from "@/api/sgccApi"

export const obtainAllAcademicsLevels = async ( { commit } ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/nivelAcademico`)
        if (data.ok) {
            commit('setAcademicsLevels', data.nivelAcademico)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}